module.exports = __webpack_public_path__ + "static/media/My-Account.a7f6df8b.svg";